import { render, staticRenderFns } from "./ClientTopBar.vue?vue&type=template&id=898d829e&scoped=true"
import script from "./ClientTopBar.vue?vue&type=script&lang=ts"
export * from "./ClientTopBar.vue?vue&type=script&lang=ts"
import style0 from "./ClientTopBar.vue?vue&type=style&index=0&id=898d829e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898d829e",
  null
  
)

export default component.exports